module.exports = "<!-- INPUT ELEMENT: COMMAND LINE -->\r\n<div id=\"inputEditor\" [hidden]=\"this.blocks.isBlockMode()\" tabindex=\"1\"></div>\r\n\r\n<!-- CANVAS COMPONENT: DRAWING -->\r\n<app-canvas #canvasID ></app-canvas>\r\n\r\n<div [hidden]=\"this.blocks.isBlockMode()\" style=\"height: 25%\">\r\n\t<!-- WATCH COMPONENT: DEBUG VARIABLES -->\r\n\t<app-debug-watch></app-debug-watch>\r\n\r\n\t<!-- HISTORY COMPONENT: PRIOR COMMANDS -->\r\n\t<app-history></app-history>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/input.component.html
// module id = ./src/app/components/input.component.html
// module chunks = main